import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import { action } from 'satcheljs/lib/legacy';
import { getStore } from '../store/store';
import { trace } from 'owa-trace';
// save frequently used folder list to the server
export default action('saveFrequentlyUsedFolders')(function saveFrequentlyUsedFolders() {
    var serializedFolders = [];
    getStore().frequentlyUsedFolders.forEach(function (folder) {
        serializedFolders.push(JSON.stringify(folder));
    });
    getUserConfiguration().UserOptions.FrequentlyUsedFolders = serializedFolders;
    // Update user config
    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['FrequentlyUsedFolders'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'StringArray',
                Value: serializedFolders,
            }),
        }),
    ]).catch(function (error) {
        // no-op if FUF fails to update
        trace.warn("saveFrequentlyUsedFolders: " + error);
    });
});
//# sourceMappingURL=saveFrequentlyUsedFolders.js.map